var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_5215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7101 6.4541C35.3736 8.44484 35.7378 10.5745 35.7378 12.7874C35.7378 19.9757 31.778 26.2072 26.0804 29.7319C26.0156 29.772 25.9508 29.8152 25.886 29.8522C25.8644 29.8646 25.8428 29.88 25.8212 29.8924C24.1144 30.8985 22.1267 31.4788 20.0033 31.4788C13.6669 31.4788 8.52797 26.3399 8.52797 20.0035C8.52797 16.0498 10.528 12.5621 13.5712 10.5004C8.25328 13.7473 4.26562 20.2905 4.26562 27.2164C4.26562 29.4325 4.63291 31.5652 5.29958 33.5559C8.9539 37.5189 14.1885 40.0035 20.0033 40.0035C31.0496 40.0035 40.0033 31.0498 40.0033 20.0035C40.0033 14.7751 37.9971 10.0189 34.7132 6.45719L34.7101 6.4541Z",
    fill: "url(#paint0_linear_334_5215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5679 10.4969C15.4012 9.25309 17.6173 8.52469 20 8.52469C26.3364 8.52469 31.4753 13.6636 31.4753 20C31.4753 24.1019 29.321 27.7006 26.0802 29.7284C31.7778 26.2037 35.7377 19.9722 35.7377 12.7839C35.7377 10.5679 35.3735 8.44136 34.7099 6.45062C31.0556 2.48765 25.8179 0 20 0C8.9537 0 0 8.9537 0 20C0 25.2315 2.00926 29.9907 5.2963 33.5525C4.62963 31.5586 4.26235 29.429 4.26235 27.213C4.26235 20.284 8.25 13.7438 13.5679 10.4969Z",
    fill: "url(#paint1_linear_334_5215)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_5215",
    x1: 4.52838,
    y1: 33.2079,
    x2: 37.357,
    y2: 12.8281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106093,
    stopColor: "#007D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402219,
    stopColor: "#20C997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697538,
    stopColor: "#007D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953216,
    stopColor: "#20C997"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_334_5215",
    x1: 0.262751,
    y1: 26.7563,
    x2: 33.0931,
    y2: 6.3773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106093,
    stopColor: "#007D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402219,
    stopColor: "#20C997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697538,
    stopColor: "#007D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953216,
    stopColor: "#20C997"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_5215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.3cadf010d79a523764a9724c406d5570.svg";
export { ForwardRef as ReactComponent };